import TeacherAttendanceDashboardController from "./teacher_attendance_dashboard_controller";
import TeacherAttendancePointingController from "./teacher_attendance_pointing_controller";
import TeacherAttendanceManagementController from "./teacher_attendance_management_controller";
import TeacherAttendanceTeacherController from "./teacher_attendance_teacher_controller";
import TeacherAttendanceHistoryController from "./teacher_attendance_history_controller";
import TeacherAttendanceReportsController from "./teacher_attendance_reports_controller";
import TeacherAttendanceStatisticsController from "./teacher_attendance_statistics_controller";
import TeacherAttendanceSettingsController from "./teacher_attendance_settings_controller";
// Import and register all your controllers from the importmap via controllers/**/*_controller
import { application } from "./application";
import StudentListFormController from "./student_list_form_controller";

import QuizBuilderController from "./quiz_builder_controller";

import AssistantStreamController from "./assistant_stream_controller";
import G4tSelectionController from "./g4t_selection_controller";
import G4tDraftController, { G4tDraftsPurgeController } from "./g4t_draft_controller";
import G4tStaffRoomController from "./g4t_staff_room_controller";
import G4tWhatsappController from "./g4t_whatsapp_controller";
import G4tEvaluationController from "./g4t_evaluation_controller";
import G4tLevelGridController from "./g4t_level_grid_controller";
import G4tClassDrawController from "./g4t_class_draw_controller";
import G4tTimerController from "./g4t_timer_controller";
import G4tTakeoverChoicesController from "./g4t_takeover_choices_controller";
import G4tAddressController from "./g4t_address_controller";
import HeadCommentsDraftController from "./head_comments_draft_controller";
import AssistantComposerController from "./assistant_composer_controller";
import Go4siaPacksController from "./go4sia_packs_controller";
import G4lDirectorySuggestController from "./g4l_directory_suggest_controller";
import ThemeController from "./theme_controller";
import DsTabsController from "./ds_tabs_controller";
import DsDismissController from "./ds_dismiss_controller";
import DsTourController from "./ds_tour_controller";
import DsSelectController from "./ds_select_controller";
import FormRefreshController from "./form_refresh_controller";
import PageRefreshController from "./page_refresh_controller";
import NotificationBadgeController from "./notification_badge_controller";
import DsMultiselectController from "./ds_multiselect_controller";
import DsModalController from "./ds_modal_controller";
import NewsComposerController from "./news_composer_controller";
import NewsEditorController from "./news_editor_controller";
import NewsUploadController from "./news_upload_controller";
import NewsAudienceController from "./news_audience_controller";
import CashCheckController from "./cash_check_controller";
import NewsClampController from "./news_clamp_controller";
import NewsLightboxController from "./news_lightbox_controller";
import NewsLogoController from "./news_logo_controller";
import NewsFeedController from "./news_feed_controller";
import NewsReactionsController from "./news_reactions_controller";
import ModalOpenerController from "./modal_opener_controller";
import MakeupBlendController from "./makeup_blend_controller";
import DsToastController from "./ds_toast_controller";
import DsToastDemoController from "./ds_toast_demo_controller";
import DsTableController from "./ds_table_controller";
import DsShellController from "./ds_shell_controller";
import DsExportController from "./ds_export_controller";
import DsCollapseController from "./ds_collapse_controller";
import DsMenuController from "./ds_menu_controller";
// Hors du motif ds_*_controller, que l'espace élève charge en entier.
import DsNavgroupsController from "./navgroups_controller";
import DsPillController from "./ds_pill_controller";
import DsDropzoneController from "./ds_dropzone_controller";
import BulkFilePickController from "./bulk_file_pick_controller";
import BulkFileSendController from "./bulk_file_send_controller";
import DsTagfieldController from "./ds_tagfield_controller";
import ConfirmedDownloadController from "./confirmed_download_controller";
import ConfirmSubmitController from "./confirm_submit_controller";
import FormErrorsController from "./form_errors_controller";
import BrandingReuseController from "./branding_reuse_controller";
import BrandingColorsController from "./branding_colors_controller";
import NotificationController from "./notification_controller";
import AbsenceFiltersController from "./absence_filters_controller";
import AudienceSelectionController from "./audience_selection_controller";
import AbsenceRecordsController from "./absence_records_controller";
import AcademicYearManagerController from "./academic_year_manager_controller";
import AccordionController from "./accordion_controller";
import AuthLayoutController from "./auth_layout_controller";
import AutoSubmitController from "./auto_submit_controller";
import ReceiptPrintController from "./receipt_print_controller";
import MoratoriumPlanController from "./moratorium_plan_controller";
import WishDayController from "./wish_day_controller";
import RequireChoiceController from "./require_choice_controller";
import AutomaticEntriesController from "./automatic_entries_controller";
import BalanceChartController from "./balance_chart_controller";
import CashFlowChartController from "./cash_flow_chart_controller";
import LevelClassroomsController from "./level_classrooms_controller";
import BalanceSheetChartController from "./balance_sheet_chart_controller";
import ChartController from "./chart_controller";
import CollapsibleController from "./collapsible_controller";
import ColorPickerController from "./color_picker_controller";
import CompanionFormController from "./companion_form_controller";
import ContractFormController from "./contract_form_controller";
import CustomSanctionController from "./custom_sanction_controller";
import DropdownController from "./dropdown_controller";
import ExpenseDeleteController from "./expense_delete_controller";
import FilterFormController from "./filter_form_controller";
import HelloController from "./hello_controller";
import HolidaysManagerController from "./holidays_manager_controller";
import IncomeStatementChartController from "./income_statement_chart_controller";
import InventoryAssignmentController from "./inventory_assignment_controller";
import InventoryCountController from "./inventory_count_controller";
import InventoryFormController from "./inventory_form_controller";
import InventoryReportController from "./inventory_report_controller";
import BonusCategoriesController from "./bonus_categories_controller";
import IseBonusFormController from "./ise_bonus_form_controller";
import IseCalculationController from "./ise_calculation_controller";
import IseParentFilterController from "./ise_parent_filter_controller";
import IseResultsFilterController from "./ise_results_filter_controller";
import JobFunctionManagerController from "./job_function_manager_controller";
import KindergartenController from "./kindergarten_controller";
import LeaveBalanceController from "./leave_balance_controller";
import LeaveRequestController from "./leave_request_controller";
import LeaveRequestDrawerController from "./leave_request_drawer_controller";
import LeaveTypesController from "./leave_types_controller";
import ModalController from "./modal_controller";
import NestedFormController from "./nested_form_controller";
import OneSignalController from "./onesignal_controller";
import PayrollTransactionsController from "./payroll_transactions_controller";
import PedagogicalProjectController from "./pedagogical_project_controller";
import RangeSliderController from "./range_slider_controller";
import SchoolDocumentsManagerController from "./school_documents_manager_controller";
import SchoolSettingController from "./school_setting_controller";
import SchoolStaffManagerController from "./school_staff_manager_controller";
import SearchFormController from "./search_form_controller";
import StatisticsController from "./statistics_controller";
import StockItemFormController from "./stock_item_form_controller";
import StockMovementFormController from "./stock_movement_form_controller";
import StockItemLocationController from "./stock_item_location_controller";
import SupplierQuoteFormController from "./supplier_quote_form_controller";
import SupplierQuoteItemController from "./supplier_quote_item_controller";
import SwalController from "./swal_controller";
import TabsController from "./tabs_controller";
import TimezoneDetectorController from "./timezone_detector_controller";
import TurboModalController from "./turbo_modal_controller";
import UploadFileController from "./upload_file_controller";
import CheckoutController from "../../controllers/checkout_controller";
import MobileMoneyCheckoutController from "../../controllers/mobile_money_checkout_controller";
import PaymentReceiptController from "../../controllers/payment_receipt_controller";
import SmsCatalogueController from "../../controllers/sms_catalogue_controller";
import OnlinePaymentController from "../../controllers/online_payment_controller";
import OfflinePaymentController from "../../controllers/offline_payment_controller";
import PartialPaymentController from "../../controllers/partial_payment_controller";

// Import des contrôleurs de rapports
import AbsenceChartController from "./absence_chart_controller";
import AbsenceReportChartController from "./absence_report_chart_controller";
import BulkSelectionController from "./bulk_selection_controller";
import CredentialBatchController from "./credential_batch_controller";
import CredentialBatchProgressController from "./credential_batch_progress_controller";
import BulkValidationController from "./bulk_validation_controller";
import BatchProgressController from "./batch_progress_controller";
import ClassNameFormController from "../../controllers/class_name_form_controller";
import CompetencePaginationController from "./competence_pagination_controller";
import DrawerController from "./drawer_controller";
import EmailValidationController from "./email_validation_controller";
import EmployeeProfilesController from "./employee_profiles_controller";
import EmployeeProfilesFiltersController from "./employee_profiles_filters_controller";
import EvaluationsDashboardController from "./evaluations_dashboard_controller";
import EvaluationsTabsController from "./evaluations_tabs_controller";
import AsyncExportController from "./async_export_controller";
import ExportFieldsController from "./export_fields_controller";
import ExportFormController from "../../controllers/export_form_controller";
import ExportStatusController from "../../controllers/export_status_controller";
// import ExportsTableController from "./exports_table_controller";
import FeesConfigController from "./fees_config_controller";
import GooglePlacesController from "./google_places_controller";
import CouncilMentionScaleController from "./council_mention_scale_controller";
import TableRowsController from "./table_rows_controller";
import CheckboxRevealController from "./checkbox_reveal_controller";
import CheckAllController from "./check_all_controller";
import CashRulesController from "./cash_rules_controller";
import CashCollectController from "./cash_collect_controller";
import SharingMatrixController from "./sharing_matrix_controller";
import ChoiceRevealController from "./choice_reveal_controller";
import OperatorPrefixController from "./operator_prefix_controller";
import GradingSystemController from "./grading_system_controller";
import HourlyRatesController from "./hourly_rates_controller";
import RecoveryUnfoldController from "./recovery_unfold_controller";
import TeachingHoursController from "./teaching_hours_controller";
import PayrollRulesController from "./payroll_rules_controller";
import HourlyRatesFiltersController from "./hourly_rates_filters_controller";
import LeaveChartController from "./leave_chart_controller";
import LeaveTypeChartController from "./leave_type_chart_controller";
import PaymentChartController from "./payment_chart_controller";
import PaymentController from "./payment_controller";
import PayrollCalculatorController from "./payroll_calculator_controller";

import PayrollDashboardController from "./payroll_dashboard_controller";
import PayslipFilterController from "./payslip_filter_controller";
import PayslipFormController from "./payslip_form_controller";
import PayslipBulkRegenerateController from "./payslip_bulk_regenerate_controller";
import PayslipGenerationController from "./payslip_generation_controller";
import PilotInspectionFormController from "./pilot_inspection_form_controller";
import PilotReportProgressController from "./pilot_report_progress_controller";
import PilotSearchController from "./pilot_search_controller";
import PilotSidebarController from "../../controllers/pilot_sidebar_controller";
import PilotPermissionCheckboxesController from "../../controllers/pilot_permission_checkboxes_controller";
import SchoolMapController from "../../controllers/school_map_controller";
import BusLiveMapController from "../../controllers/bus_live_map_controller";
import AnalyticsMapController from "../../controllers/analytics_map_controller";
import AnalyticsLiveController from "../../controllers/analytics_live_controller";
import StopMapPickerController from "../../controllers/stop_map_picker_controller";
import AssignCircuitController from "../../controllers/assign_circuit_controller";
import RemindersController from "./reminders_controller";
import StockSearchController from "./stock_search_controller";
import SalaryAdvanceController from "./salary_advance_controller";
import DisbursementSourceController from "./disbursement_source_controller";
import DueAmountController from "./due_amount_controller";
import StaffAppraisalsFiltersController from "./staff_appraisals_filters_controller";
import ReportCardPreviewController from "./report_card_preview_controller";
import TinymceController from "./tinymce_controller";
import FlatpickrController from "./flatpickr_controller";
import FramePollController from "./frame_poll_controller";
import ResultDocumentFormController from "./result_document_form_controller";
import SupplierTermsController from "./supplier_terms_controller";
import InsightsPeriodController from "./insights_period_controller";
import CheckboxLimitController from "./checkbox_limit_controller";
import ReportProgressController from "./report_progress_controller";
import SessionSignatureController from "./session_signature_controller";
import SignatoryFormController from "./signatory_form_controller";
import SignatoryPickerController from "./signatory_picker_controller";
import SignatureFormController from "./signature_form_controller";
import SignatureStampController from "./signature_stamp_controller";
import ListFilterController from "./list_filter_controller";
import LiveFiltersController from "./live_filters_controller";
import StudentAccessController from "../../controllers/student_access_controller";
import DsfGenerationProgressController from "./dsf_generation_progress_controller";
import DsfFicheFormController from "./dsf_fiche_form_controller";
import DsfNoteCalculatorController from "./dsf_note_calculator_controller";
import SidebarGroupController from "../../controllers/sidebar_group_controller";
import AdminStaffFormController from "../../controllers/admin_staff_form_controller";
import Go4schoolSettingFormController from "../../controllers/go4school_setting_form_controller";
import BalanceSheetAccordionController from "./balance_sheet_accordion_controller";
import BalanceSheetFiltersController from "./balance_sheet_filters_controller";
import ExportProgressController from "./export_progress_controller";
import RetryAccountingEntryController from "./retry_accounting_entry_controller";
import FrameReloadController from "./frame_reload_controller";
import SignaturePadController from "./signature_pad_controller";
import CollectionSearchController from "./collection_search_controller";
import CollectionSheetController from "./collection_sheet_controller";
import BursarPayerController from "./bursar_payer_controller";
import CounterAmountController from "./counter_amount_controller";
import RemittanceTotalsController from "./remittance_totals_controller";
import ReportCardPeriodFilterController from "./report_card_period_filter_controller";
import IntlTelInputController from "../../controllers/intl_tel_input_controller";
import MoratoriumFormController from "../../controllers/moratorium_form_controller";
import NewsletterModalController from "../../controllers/newsletter_modal_controller";
import NewsletterSidebarController from "../../controllers/newsletter_sidebar_controller";
import DiscountAssignmentController from "./discount_assignment_controller";
import MessagingChartController from "./messaging_chart_controller";
import NotificationSettingsController from "./notification_settings_controller";
import SmsDetailModalController from "./sms_detail_modal_controller";
import SchoolPillSelectorController from "./school_pill_selector_controller";

application.register("quiz-builder", QuizBuilderController);
application.register("news-composer", NewsComposerController);
application.register("news-editor", NewsEditorController);
application.register("news-upload", NewsUploadController);
application.register("news-audience", NewsAudienceController);
application.register("cash-check", CashCheckController);
application.register("news-clamp", NewsClampController);
application.register("news-lightbox", NewsLightboxController);
application.register("news-logo", NewsLogoController);
application.register("news-feed", NewsFeedController);
application.register("news-reactions", NewsReactionsController);
application.register("evaluations-tabs", EvaluationsTabsController);
application.register("list-filter", ListFilterController);
application.register("live-filters", LiveFiltersController);
application.register("student-access", StudentAccessController);
application.register("sidebar-group", SidebarGroupController);
application.register("credential-batch", CredentialBatchController);
application.register("credential-batch-progress", CredentialBatchProgressController);
application.register("admin-staff-form", AdminStaffFormController);
application.register("go4school-setting-form", Go4schoolSettingFormController);

application.register("notification", NotificationController);
application.register("absence-records", AbsenceRecordsController);
application.register("pedagogical-project", PedagogicalProjectController);
application.register("reminder", RemindersController);
application.register("academic-year-manager", AcademicYearManagerController);
application.register("auto-submit", AutoSubmitController);
application.register("receipt-print", ReceiptPrintController);
application.register("moratorium-plan", MoratoriumPlanController);
application.register("wish-day", WishDayController);
application.register("require-choice", RequireChoiceController);
application.register("automatic-entries", AutomaticEntriesController);
application.register("dropdown", DropdownController);
application.register("hello", HelloController);
application.register("absence-filters", AbsenceFiltersController);
application.register("search-form", SearchFormController);
application.register("stock-search", StockSearchController);
application.register("chart", ChartController);
application.register("collapsible", CollapsibleController);
application.register("custom-sanction", CustomSanctionController);
application.register("school-staff-manager", SchoolStaffManagerController);
application.register("job-function-manager", JobFunctionManagerController);
// Register controllers with Stimulus application
application.register("holidays-manager", HolidaysManagerController);
application.register(
  "school-documents-manager",
  SchoolDocumentsManagerController
);
application.register("statistics", StatisticsController);
application.register("tabs", TabsController);
application.register("turbo-modal", TurboModalController);
application.register("modal", ModalController);
application.register("onesignal", OneSignalController);
application.register("stock-movement-form", StockMovementFormController);
application.register("stock-item-location", StockItemLocationController);
application.register("stock-item-form", StockItemFormController);
application.register("filter-form", FilterFormController);
application.register("inventory-form", InventoryFormController);
application.register("inventory-count", InventoryCountController);
application.register("inventory-report", InventoryReportController);
application.register("supplier-quote-item", SupplierQuoteItemController);
application.register("supplier-quote-form", SupplierQuoteFormController);
application.register("accordion", AccordionController);
application.register("auth-layout", AuthLayoutController);
application.register("inventory-assignment", InventoryAssignmentController);
// application.register("invoice-form", InvoiceFormController);
application.register("bonus-categories", BonusCategoriesController);
application.register("ise-bonus-form", IseBonusFormController);
application.register("ise-calculation", IseCalculationController);
application.register("ise-parent-filter", IseParentFilterController);
application.register("ise-results-filter", IseResultsFilterController);
application.register("kindergarten", KindergartenController);
application.register("nested-form", NestedFormController);
// application.register("popover-menu", PopoverMenuController);
// application.register("purchase-order-form", PurchaseOrderFormController);
// application.register("purchase-order-item", PurchaseOrderItemController);
// application.register("purchase-order-items", PurchaseOrderItemsController);
// application.register("roles-manager", RolesManagerController);
// application.register("transaction-form", TransactionFormController);
application.register("drawer", DrawerController);

// Register new chart controllers
application.register("balance-chart", BalanceChartController);
application.register("cash-flow-chart", CashFlowChartController);
application.register("level-classrooms", LevelClassroomsController);
application.register("balance-sheet-chart", BalanceSheetChartController);
application.register("income-statement-chart", IncomeStatementChartController);
application.register("upload-file", UploadFileController);
application.register("leave-types", LeaveTypesController);
application.register("color-picker", ColorPickerController);
application.register("leave-balance", LeaveBalanceController);
application.register("leave-request", LeaveRequestController);
application.register("leave-request-drawer", LeaveRequestDrawerController);
application.register("school-setting", SchoolSettingController);

// Enregistrement des contrôleurs de rapports
application.register("absence-chart", AbsenceChartController);
application.register("reports-leave-chart", LeaveChartController);
application.register("leave-type-chart", LeaveTypeChartController);
application.register("evaluations-dashboard", EvaluationsDashboardController);
application.register("payroll-transactions", PayrollTransactionsController);
application.register("swal", SwalController);
application.register(
  "employee-profiles-filters",
  EmployeeProfilesFiltersController
);
application.register("employee-profiles", EmployeeProfilesController);
application.register("hourly-rates", HourlyRatesController);
application.register("recovery-unfold", RecoveryUnfoldController);
application.register("teaching-hours", TeachingHoursController);
application.register("payroll-rules", PayrollRulesController);
application.register("hourly-rates-filters", HourlyRatesFiltersController);
application.register("salary-advance", SalaryAdvanceController);
application.register("disbursement-source", DisbursementSourceController);
application.register("due-amount", DueAmountController);
application.register("payslip-form", PayslipFormController);
application.register("payslip-filter", PayslipFilterController);
application.register("payslip-bulk-regenerate", PayslipBulkRegenerateController);
application.register("payslip-generation", PayslipGenerationController);
application.register("pilot-inspection-form", PilotInspectionFormController);
application.register("pilot-report-progress", PilotReportProgressController);
application.register("pilot-search", PilotSearchController);
application.register("pilot-sidebar", PilotSidebarController);
application.register("pilot-permission-checkboxes", PilotPermissionCheckboxesController);
application.register("school-map", SchoolMapController);
application.register("bus-live-map", BusLiveMapController);
application.register("analytics-map", AnalyticsMapController);
application.register("analytics-live", AnalyticsLiveController);
application.register("stop-map-picker", StopMapPickerController);
application.register("assign-circuit", AssignCircuitController);
application.register("payment", PaymentController);
application.register("payment-chart", PaymentChartController);
application.register("payroll-dashboard", PayrollDashboardController);
application.register("email-validation", EmailValidationController);
application.register("async-export", AsyncExportController);
application.register("export-fields", ExportFieldsController);
application.register("export-form", ExportFormController);
application.register("export-status", ExportStatusController);
application.register(
  "staff-appraisals-filters",
  StaffAppraisalsFiltersController
);
// application.register("fees-config", FeesConfigController); // TODO: Import FeesConfigController or remove this line
application.register("bulk-selection", BulkSelectionController);
application.register("bulk-validation", BulkValidationController);
application.register("batch-progress", BatchProgressController);
application.register("timezone-detector", TimezoneDetectorController);
application.register("payroll-calculator", PayrollCalculatorController);

application.register("range-slider", RangeSliderController);
application.register("expense-delete", ExpenseDeleteController);
application.register("council-mention-scale", CouncilMentionScaleController);
application.register("table-rows", TableRowsController);
application.register("checkbox-reveal", CheckboxRevealController);
application.register("check-all", CheckAllController);
application.register("cash-rules", CashRulesController);
application.register("cash-collect", CashCollectController);
application.register("sharing-matrix", SharingMatrixController);
application.register("choice-reveal", ChoiceRevealController);
application.register("operator-prefix", OperatorPrefixController);
application.register("grading-system", GradingSystemController);
application.register("report-card-preview", ReportCardPreviewController);
application.register(
  "teacher-attendance-dashboard",
  TeacherAttendanceDashboardController
);
application.register(
  "teacher-attendance-pointing",
  TeacherAttendancePointingController
);
application.register(
  "teacher-attendance-management",
  TeacherAttendanceManagementController
);
application.register(
  "teacher-attendance-teacher",
  TeacherAttendanceTeacherController
);
application.register(
  "teacher-attendance-history",
  TeacherAttendanceHistoryController
);
application.register(
  "teacher-attendance-reports",
  TeacherAttendanceReportsController
);
application.register(
  "teacher-attendance-statistics",
  TeacherAttendanceStatisticsController
);
application.register(
  "teacher-attendance-settings",
  TeacherAttendanceSettingsController
);
application.register("tinymce", TinymceController);
application.register("flatpickr", FlatpickrController);
application.register("frame-poll", FramePollController);
application.register("result-document-form", ResultDocumentFormController);
application.register("supplier-terms", SupplierTermsController);
application.register("insights-period", InsightsPeriodController);
application.register("checkbox-limit", CheckboxLimitController);
application.register("report-progress", ReportProgressController);
application.register("google_places", GooglePlacesController);
application.register("session-signature", SessionSignatureController);
application.register("signatory-form", SignatoryFormController);
application.register("signatory-picker", SignatoryPickerController);
application.register("signature-form", SignatureFormController);
application.register("signature-stamp", SignatureStampController);
application.register("contract-form", ContractFormController);
application.register("audience-selection", AudienceSelectionController);
application.register("dsf-generation-progress", DsfGenerationProgressController);
application.register("dsf-fiche-form", DsfFicheFormController);
application.register("dsf-note-calculator", DsfNoteCalculatorController);
application.register("checkout", CheckoutController);
application.register("mobile-money-checkout", MobileMoneyCheckoutController);
application.register("payment-receipt", PaymentReceiptController);
application.register("sms-catalogue", SmsCatalogueController);
application.register("online-payment", OnlinePaymentController);
application.register("offline-payment", OfflinePaymentController);
application.register("partial-payment", PartialPaymentController);
application.register("balance-sheet-accordion", BalanceSheetAccordionController);
application.register("balance-sheet-filters", BalanceSheetFiltersController);
application.register("export-progress", ExportProgressController);
application.register("retry-accounting-entry", RetryAccountingEntryController);
application.register("frame-reload", FrameReloadController);
application.register("signature-pad", SignaturePadController);
application.register("collection-search", CollectionSearchController);
application.register("collection-sheet", CollectionSheetController);
application.register("bursar-payer", BursarPayerController);
application.register("counter-amount", CounterAmountController);
application.register("remittance-totals", RemittanceTotalsController);
application.register("report-card-period-filter", ReportCardPeriodFilterController);
application.register("intl-tel-input", IntlTelInputController);
application.register("moratorium-form", MoratoriumFormController);
application.register("newsletter-modal", NewsletterModalController);
application.register("newsletter-sidebar", NewsletterSidebarController);
application.register("discount-assignment", DiscountAssignmentController);
application.register("messaging-chart", MessagingChartController);
application.register("notification-settings", NotificationSettingsController);
application.register("sms-detail-modal", SmsDetailModalController);
application.register("school-pill-selector", SchoolPillSelectorController);

// Story controllers
import SlideEditorController from "../../controllers/slide_editor_controller";
import StoryBarController from "../../controllers/story_bar_controller";
import StoryViewerController from "../../controllers/story_viewer_controller";
import VideoDurationValidatorController from "../../controllers/video_duration_validator_controller";

application.register("slide-editor", SlideEditorController);
application.register("story-bar", StoryBarController);
application.register("story-viewer", StoryViewerController);
application.register("video-duration-validator", VideoDurationValidatorController);

import TemplatePickerController from "../../controllers/template_picker_controller";
application.register("template-picker", TemplatePickerController);

import TemplateSlideEditorController from "../../controllers/template_slide_editor_controller";
application.register("template-slide-editor", TemplateSlideEditorController);

import TeacherStoryAudienceController from "../../controllers/teacher_story_audience_controller";
application.register("teacher-story-audience", TeacherStoryAudienceController);

import SelectAllController from "../../controllers/select_all_controller";
application.register("select-all", SelectAllController);

import BroadcastScopeController from "../../controllers/broadcast_scope_controller";
application.register("broadcast-scope", BroadcastScopeController);

import StoryPermissionController from "../../controllers/story_permission_controller";
application.register("story-permission", StoryPermissionController);

import CommPermissionController from "../../controllers/comm_permission_controller";
application.register("comm-permission", CommPermissionController);

import TeacherCommAudienceController from "../../controllers/teacher_comm_audience_controller";
application.register("teacher-comm-audience", TeacherCommAudienceController);

import TeacherFileUploadController from "../../controllers/teacher_file_upload_controller";
application.register("teacher-file-upload", TeacherFileUploadController);

import FilePreviewController from "../../controllers/file_preview_controller";
application.register("file-preview", FilePreviewController);

import BgColorPickerController from "../../controllers/bg_color_picker_controller";
application.register("bg-color-picker", BgColorPickerController);

import NurseryMasteryChartController from "./nursery_mastery_chart_controller";
application.register("nursery-mastery-chart", NurseryMasteryChartController);

import UserChannelController from "../../controllers/user_channel_controller";
application.register("user-channel", UserChannelController);

import PresenceController from "../../controllers/presence_controller";
application.register("presence", PresenceController);

import AdminNewConversationController from "./admin_new_conversation_controller";
application.register("admin-new-conversation", AdminNewConversationController);

import PerformancePeriodFilterController from "../../controllers/performance_period_filter_controller";
application.register("performance-period-filter", PerformancePeriodFilterController);

// Pricing controllers
import PricingPlanTiersController from "../../controllers/pricing_plan_tiers_controller";
import PricingSimulatorController from "../../controllers/pricing_simulator_controller";
application.register("pricing-plan-tiers", PricingPlanTiersController);
application.register("pricing-simulator", PricingSimulatorController);

// Sector monitoring
import SurveillanceZonesController from "../../controllers/surveillance_zones_controller";
application.register("surveillance-zones", SurveillanceZonesController);

import MultiYearChartController from "../../controllers/multi_year_chart_controller";
application.register("multi-year-chart", MultiYearChartController);


import NotificationPreferencesController from "./notification_preferences_controller";
application.register("notification-preferences", NotificationPreferencesController);

import PillTabsController from "./pill_tabs_controller";
application.register("pill-tabs", PillTabsController);

import ProfileFormController from "./profile_form_controller";
import PasswordFormController from "./password_form_controller";
import PasswordVisibilityController from "./password_visibility_controller";
application.register("profile-form", ProfileFormController);
application.register("password-form", PasswordFormController);
application.register("password-visibility", PasswordVisibilityController);

import SeeMoreController from "../../controllers/see_more_controller";
application.register("see-more", SeeMoreController);

import CollapseController from "../../controllers/collapse_controller";
application.register("collapse", CollapseController);

application.register("assistant-stream", AssistantStreamController);
application.register("g4t-selection", G4tSelectionController);
application.register("g4t-draft", G4tDraftController);
application.register("g4t-drafts-purge", G4tDraftsPurgeController);
application.register("g4t-staff-room", G4tStaffRoomController);
application.register("g4t-whatsapp", G4tWhatsappController);
application.register("g4t-level-grid", G4tLevelGridController);
application.register("g4t-class-draw", G4tClassDrawController);
application.register("g4t-timer", G4tTimerController);
application.register("g4t-evaluation", G4tEvaluationController);
application.register("g4t-takeover-choices", G4tTakeoverChoicesController);
application.register("g4t-address", G4tAddressController);
application.register("head-comments-draft", HeadCommentsDraftController);
application.register("assistant-composer", AssistantComposerController);
// La trombone du coach GO4LEARN — à côté des deux autres contrôleurs du chat,
// parce qu'elle vit dans le même composeur.
import G4lCoachPhotoController from "./g4l_coach_photo_controller.js";
application.register("g4l-coach-photo", G4lCoachPhotoController);
application.register("go4sia-packs", Go4siaPacksController);
application.register("g4l-directory-suggest", G4lDirectorySuggestController);
application.register("theme", ThemeController);
application.register("ds-tabs", DsTabsController);
application.register("ds-dismiss", DsDismissController);
application.register("ds-tour", DsTourController);
application.register("ds-select", DsSelectController);
application.register("form-refresh", FormRefreshController);
application.register("page-refresh", PageRefreshController);
application.register("notification-badge", NotificationBadgeController);
application.register("ds-multiselect", DsMultiselectController);
application.register("ds-modal", DsModalController);
application.register("modal-opener", ModalOpenerController);
application.register("makeup-blend", MakeupBlendController);
application.register("ds-toast", DsToastController);
application.register("ds-toast-demo", DsToastDemoController);
application.register("ds-table", DsTableController);
application.register("ds-shell", DsShellController);
application.register("ds-export", DsExportController);
application.register("ds-collapse", DsCollapseController);
application.register("ds-menu", DsMenuController);
application.register("ds-navgroups", DsNavgroupsController);
application.register("ds-pill", DsPillController);
application.register("ds-dropzone", DsDropzoneController);
application.register("bulk-file-pick", BulkFilePickController);
application.register("bulk-file-send", BulkFileSendController);
application.register("ds-tagfield", DsTagfieldController);
application.register("confirmed-download", ConfirmedDownloadController);
application.register("confirm-submit", ConfirmSubmitController);
application.register("form-errors", FormErrorsController);
application.register("branding-reuse", BrandingReuseController);
application.register("branding-colors", BrandingColorsController);
application.register("student-list-form", StudentListFormController);
